import React from 'react';
import { UitkParagraph } from 'uitk-react-text';
import { getLocalizedText } from "src/utils/helper";
var LegalMessage = function () {
  return React.createElement(React.Fragment, null, React.createElement(UitkParagraph, {
    className: 'legal_message'
  }, getLocalizedText('listicle_legal_msg')));
};
export default LegalMessage;